import {
  DEADLINE_BG_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_EARLY,
  DEADLINE_TEXT_COLOR_OVERDUE,
  DEADLINE_TEXT_COLOR_ROLLING,
} from '../../../constants/date'
import {
  Status,
  STATUS_SIZE_16,
  STATUS_SIZE_20,
  STATUS_SIZE_24,
} from '../../Status'
import { Container } from '../Container'

import * as styles from './Deadlines.module.css'

const DATE = '06/08/2021, 12:00'

const SIZES = [STATUS_SIZE_24, STATUS_SIZE_20, STATUS_SIZE_16]

function Deadlines() {
  return (
    <>
      <Container label='Deadline, default, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            backgroundColor={DEADLINE_BG_COLOR_DEFAULT}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_DEFAULT}
          />
        ))}
      </Container>
      <Container label='Deadline, default, width 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            backgroundColor={DEADLINE_BG_COLOR_DEFAULT}
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_DEFAULT}
          />
        ))}
      </Container>
      <Container label='Deadline, default, with close button, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            backgroundColor={DEADLINE_BG_COLOR_DEFAULT}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_DEFAULT}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>
      <Container label='Deadline, default, with close button, width - 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            backgroundColor={DEADLINE_BG_COLOR_DEFAULT}
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_DEFAULT}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>

      <Container label='Deadline, rolling, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_ROLLING}
          />
        ))}
      </Container>
      <Container label='Deadline, rolling, width 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_ROLLING}
          />
        ))}
      </Container>
      <Container label='Deadline, rolling, with close button, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_ROLLING}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>
      <Container label='Deadline, rolling, with close button, width - 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_ROLLING}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>

      <Container label='Deadline, overdue, sizes - 24px, 20px, 16px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_OVERDUE}
          />
        ))}
      </Container>
      <Container label='Deadline, overdue, width 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_OVERDUE}
          />
        ))}
      </Container>
      <Container label='Deadline, overdue, with close button, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_OVERDUE}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>
      <Container label='Deadline, overdue, with close button, width - 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_OVERDUE}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>

      <Container label='Deadline, early, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_EARLY}
          />
        ))}
      </Container>
      <Container label='Deadline, early, width 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_EARLY}
          />
        ))}
      </Container>
      <Container label='Deadline, early, with close button, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_EARLY}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>
      <Container label='Deadline, early, with close button, width - 100px, sizes - 24px, 20px, 16px'>
        {SIZES.map(size => (
          <Status
            className={styles.width100}
            height={size}
            key={size}
            text={DATE}
            textColor={DEADLINE_TEXT_COLOR_EARLY}
            onRemove={() => {
              console.log()
            }}
          />
        ))}
      </Container>
    </>
  )
}

export default Deadlines
